export default __webpack_public_path__ + "static/project-slide-3-4032-2268-3058c4cd87c38439d2800f6af631f6d7.jpg";